/* Mae Jum product extras: bundle selector visual system */
(function () {
  'use strict';

  /* ── helpers ─────────────────────────────────────────────────────── */

  function handleFromUrl(url) {
    if (!url) return null;
    var parts = url.split('/');
    var idx = parts.indexOf('products');
    return idx !== -1 ? parts[idx + 1].split('?')[0] : null;
  }

  function isHandleBundle(handle) {
    return !!(handle && handle.indexOf('bundle') !== -1);
  }

  /* ── Page context ───────────────────────────────────────────────── */

  var _pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
  var currentPageHandle = _pathMatch ? _pathMatch[1] : '';
  var currentPageIsBundle = isHandleBundle(currentPageHandle);

  /* ── Bundle state — set by Liquid on bundle pages ───────────────── */

  var bundleHandles = window.mjBundleHandles || [];
  var bundleQtys = window.mjBundleQtys || {};
  var _bundleQtyMap = {};

  /* ── Quantity helpers ────────────────────────────────────────────── */

  var _packMultiplier = 1;
  var _priceObserver = null;

  function parsePackMultiplier(title) {
    if (!title) return 1;
    if (/\b6\b/.test(title)) return 6;
    if (/\b3\b/.test(title)) return 3;
    return 1;
  }

  function getSelectedVariantFromDOM() {
    // MiniMog keeps [data-selected-variant] script tag content current after every variant change
    var script = document.querySelector('variant-picker [data-selected-variant]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function initPackMultiplier() {
    var v = getSelectedVariantFromDOM();
    if (v && v.title) { _packMultiplier = parsePackMultiplier(v.title); return; }
    // Fallback: read combined option label text (MiniMog updates .option-label--selected on change)
    var labels = document.querySelectorAll('.option-label--selected');
    if (labels.length) {
      var combined = Array.prototype.map.call(labels, function (l) { return l.textContent; }).join(' ');
      _packMultiplier = parsePackMultiplier(combined);
    }
  }

  function getQtyInputValue() {
    var inp = document.querySelector('.m-product-form--input input[type="number"]');
    return inp ? Math.max(1, parseInt(inp.value, 10) || 1) : 1;
  }

  /* ── Tile rendering ─────────────────────────────────────────────── */

  function setTileAmber(tile, qtyText) {
    // Apply amber outline to the .variant-products wrapper (encompasses image + label)
    var wrapper = (tile.parentElement && tile.parentElement.classList.contains('variant-products'))
      ? tile.parentElement : tile;
    wrapper.classList.add('mj-amber');

    // Badge is positioned relative to the <a> tile (image area)
    tile.style.position = 'relative';
    var badge = tile.querySelector('.mj-bundle-qty');
    if (qtyText) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'mj-bundle-qty';
        tile.appendChild(badge);
      }
      badge.textContent = qtyText;
    } else {
      if (badge) badge.remove();
    }
  }

  function clearTile(tile) {
    var wrapper = (tile.parentElement && tile.parentElement.classList.contains('variant-products'))
      ? tile.parentElement : tile;
    wrapper.classList.remove('mj-amber');
    tile.classList.remove('mj-tile-selected');
    var badge = tile.querySelector('.mj-bundle-qty');
    if (badge) badge.remove();
  }

  function clearAllTiles() {
    document.querySelectorAll('.variant-products.mj-amber').forEach(function (el) {
      el.classList.remove('mj-amber');
    });
    document.querySelectorAll('.mj-tile-selected').forEach(function (el) {
      el.classList.remove('mj-tile-selected');
    });
    document.querySelectorAll('.mj-bundle-qty').forEach(function (el) {
      el.remove();
    });
  }

  function setTileInfo(tile) {
    // Info badge — static green tick, no quantity
    var wrapper = (tile.parentElement && tile.parentElement.classList.contains('variant-products'))
      ? tile.parentElement : tile;
    wrapper.classList.add('mj-amber');
    tile.style.position = 'relative';
    var badge = tile.querySelector('.mj-bundle-qty');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'mj-bundle-qty';
      tile.appendChild(badge);
    }
    badge.textContent = '✓';
  }

  /* ── Bundle qty map — built from data-bundle-handles/qtys on DOM tiles ── */

  function buildBundleQtyMap() {
    _bundleQtyMap = {};
    document.querySelectorAll('.related-product[data-bundle-handles]').forEach(function (tile) {
      var bHandle = handleFromUrl(tile.getAttribute('href'));
      if (!bHandle) return;
      var handles = tile.getAttribute('data-bundle-handles').split(',');
      var qtys = (tile.getAttribute('data-bundle-qtys') || '').split(',');
      handles.forEach(function (h, i) {
        h = h.trim();
        if (h) _bundleQtyMap[bHandle + ':' + h] = parseInt(qtys[i], 10) || 1;
      });
    });
  }

  /* ── Bundle page ────────────────────────────────────────────────── */

  function renderBundlePage() {
    document.body.classList.add('mj-is-bundle-page');
    var cartQty = getQtyInputValue();

    document.querySelectorAll('.related-product').forEach(function (tile) {
      var handle = handleFromUrl(tile.getAttribute('href'));
      if (!handle) { clearTile(tile); return; }

      if (isHandleBundle(handle)) {
        if (handle === currentPageHandle) {
          setTileAmber(tile, String(getQtyInputValue()));
        } else {
          clearTile(tile);
        }
        return;
      }

      // Single paste tile
      var compositeKey = currentPageHandle + ':' + handle;
      if (_bundleQtyMap[compositeKey] !== undefined) {
        if (tile.closest('.mj-single-pack')) {
          setTileInfo(tile);
        } else {
          var baseQty = _bundleQtyMap[compositeKey];
          var totalQty = baseQty * cartQty * _packMultiplier;
          setTileAmber(tile, String(totalQty));
        }
      } else {
        clearTile(tile);
      }
    });
    document.querySelectorAll('.mj-bundle-legend').forEach(function (el) { el.style.display = 'inline'; });
  }

  /* ── Single paste page ──────────────────────────────────────────── */

  function renderSinglePastePage() {
    document.body.classList.remove('mj-is-bundle-page');
    var qty = getQtyInputValue() * _packMultiplier;

    document.querySelectorAll('.related-product').forEach(function (tile) {
      var handle = handleFromUrl(tile.getAttribute('href'));
      if (!handle) { clearTile(tile); return; }

      if (isHandleBundle(handle) || handle !== currentPageHandle) {
        clearTile(tile);
      } else {
        tile.classList.add('mj-tile-selected');
        setTileAmber(tile, String(qty));
      }
    });
    document.querySelectorAll('.mj-bundle-legend').forEach(function (el) { el.style.display = 'none'; });
  }

  /* ── Render dispatcher ──────────────────────────────────────────── */

  function renderTiles() {
    clearAllTiles();
    if (currentPageIsBundle) {
      renderBundlePage();
    } else {
      renderSinglePastePage();
    }
  }

  /* ── Tile click navigation ───────────────────────────────────────── */

  function handleSwatchClick(e) {
    var href = this.getAttribute('href');
    var handle = handleFromUrl(href);
    if (!handle) return;

    if (isHandleBundle(handle)) return;

    var scrollY = window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop || 0;
    sessionStorage.setItem('mj-scroll-y', String(scrollY));

    if (currentPageIsBundle) {
      e.preventDefault();
      var base = href.split('?')[0];
      window.location.href = base + '?bundle=' + encodeURIComponent(currentPageHandle);
    }
  }

  function bindSwatches() {
    document.querySelectorAll('.related-product').forEach(function (link) {
      link.removeEventListener('click', handleSwatchClick);
      link.addEventListener('click', handleSwatchClick);
    });
  }

  /* ── MutationObserver fallback — fires when price element updates ─── */

  function attachPriceObserver() {
    if (_priceObserver) { _priceObserver.disconnect(); _priceObserver = null; }
    var priceEl = document.querySelector('[id^="Price-"]') ||
                  document.querySelector('.m-product__price, .m-price');
    if (!priceEl) return;
    _priceObserver = new MutationObserver(function () {
      var v = getSelectedVariantFromDOM();
      if (v && v.title) _packMultiplier = parsePackMultiplier(v.title);
      renderTiles();
    });
    _priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
  }

  /* ── Event listeners ────────────────────────────────────────────── */

  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant) {
      _packMultiplier = parsePackMultiplier(e.detail.variant.title);
    }
    renderTiles();
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'number') renderTiles();
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.type === 'number') renderTiles();
  });

  /* ── Scroll restore — one-shot guard prevents double execution ─────── */

  var scrollRestored = false;

  function doScrollRestore() {
    var savedY = sessionStorage.getItem('mj-scroll-y');
    if (!savedY || scrollRestored) return;
    var y = parseInt(savedY, 10);
    sessionStorage.removeItem('mj-scroll-y');
    document.documentElement.style.opacity = '0';
    setTimeout(function () {
      if (!scrollRestored) {
        scrollRestored = true;
        window.scrollTo({ top: y, behavior: 'instant' });
        document.documentElement.scrollTop = y;
        document.body.scrollTop = y;
      }
      document.documentElement.style.opacity = '1';
    }, 300);
  }

  /* ── View Transition reinit ─────────────────────────────────────── */

  window.addEventListener('pagereveal', function () {
    // Refresh page context — same-document VT navigation does not re-run the IIFE
    var pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
    currentPageHandle = pathMatch ? pathMatch[1] : '';
    currentPageIsBundle = isHandleBundle(currentPageHandle);
    bundleHandles = window.mjBundleHandles || [];
    bundleQtys = window.mjBundleQtys || {};

    _packMultiplier = 1;
    if (_priceObserver) { _priceObserver.disconnect(); _priceObserver = null; }
    buildBundleQtyMap();
    initPackMultiplier();
    bindSwatches();
    renderTiles();
    attachPriceObserver();

    doScrollRestore();
  });

  /* ── Fallback scroll restore on load (if pagereveal does not fire) ── */

  window.addEventListener('load', function () {
    doScrollRestore();
  });

  /* ── init ─────────────────────────────────────────────────────────── */

  function init() {
    buildBundleQtyMap();
    initPackMultiplier();
    bindSwatches();
    renderTiles();
    attachPriceObserver();
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
